import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark bg-dark" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, "Protospiel.Events", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#mainnavcontent",
  "aria-controls": "mainnavcontent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "mainnavcontent"
}
const _hoisted_6 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, null, -1)
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-6 col-lg-9" }
const _hoisted_17 = { class: "col-md-6 col-lg-3" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<nav class=\"navbar navbar-expand-lg navbar-dark bg-dark\"><div class=\"container\"><ul class=\"navbar-nav me-auto mb-2 mb-lg-0\"><li class=\"nav-item\"></li><li class=\"nav-item\"><a href=\"https://github.com/plainblack/protospielevents/issues\" class=\"nav-link\">Report Problem</a></li><li class=\"nav-item\"><a href=\"https://github.com/plainblack/protospielevents\" class=\"nav-link\">Source Code</a></li></ul></div></nav>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_UpcomingEvents = _resolveComponent("UpcomingEvents")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/attending"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Attending")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/organizing"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Organizing")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/marketing"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Marketing")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/upcoming-events"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Upcoming Events")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/policies"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Policies")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/bingo"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Bingo")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_router_view)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_UpcomingEvents)
        ])
      ])
    ]),
    _hoisted_18
  ], 64))
}